import * as Sentry from "@sentry/vue";
import type { SpanJSON } from '@sentry/core';

export default defineNuxtPlugin(app => {
  const transactionLogging = localStorage.getItem('transactionLogging') !== null;
  const tracesSampleRate = parseFloat(app.$config.public.sentry.traces.sampleRate) || 0.25;
  let isInitialized = false;

  const spanFilter = (span: SpanJSON) => {
    if (span.op === 'resource.script' || span.op === 'resource.link') {
      if (span.description?.includes('/_nuxt/')) {
        return false;
      }
    }

    return span;
  };

  const initSentry = () => {
    Sentry.init({
      app: app.vueApp,
      dsn: "https://1690e342220e79fcb66c94b98d68a601@o4507412248395776.ingest.de.sentry.io/4507452801482832",
      release: `learning-app@${app.$config.public.gitInfo}`,
      environment: app.$config.public.env,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ['error'],
        }),
      ],

      ignoreSpans: [
        '.clarity.ms',
        '.varify.io',
        'bt.fraud0.com',
        'freshworks.com',
        'status.medmastery.com',
        '.cookiebot.com',
        'fbevents:',
        'sst.medmastery.com',
        { op: 'link:prefetch' },
        { op: 'measure' },

      ],
      beforeSendTransaction: transaction => {
        if (transactionLogging) {
          console.debug('Sentry-Transaction', transaction.spans?.length);
        }

        transaction.spans = transaction.spans?.filter(spanFilter);

        return transaction;
      },
      tracesSampler: samplingContext => {
        if (samplingContext.name?.includes('/enroll')) {
          return 0.5;
        }

        return tracesSampleRate;
      },
      tracePropagationTargets: ["app.medmastery.com/api"],
    });

    isInitialized = true;
  };

  if (app.$config.public.env === 'production') {
    initSentry();
  } else {
    console.warn('Sentry is only enabled in production environment.');
  }

  const wrapper = (fn: (...args: any[]) => void) => {
    if (isInitialized) {
      return fn;
    } else {
      console.warn('Sentry is not initialized.');
      return () => {};
    }
  };

  return {
    provide: {
      sentry: {
        captureException: wrapper(Sentry.captureException),
        captureMessage: wrapper(Sentry.captureMessage),
      },
    },
  };
});